import React from 'react'

const VarientSingle = () => {
  return (
    <div>VarientSingle</div>
  )
}

export default VarientSingle